import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\GetDraftSupplierOrdersBySupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetDraftSupplierOrdersBySupplierController.php
* @route '/api/supplier/{supplier}/draft-supplier-orders'
*/
const GetDraftSupplierOrdersBySupplierController = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDraftSupplierOrdersBySupplierController.url(args, options),
    method: 'get',
})

GetDraftSupplierOrdersBySupplierController.definition = {
    methods: ["get","head"],
    url: '/api/supplier/{supplier}/draft-supplier-orders',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SupplierOrder\GetDraftSupplierOrdersBySupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetDraftSupplierOrdersBySupplierController.php
* @route '/api/supplier/{supplier}/draft-supplier-orders'
*/
GetDraftSupplierOrdersBySupplierController.url = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier: typeof args.supplier === 'object'
        ? args.supplier.id
        : args.supplier,
    }

    return GetDraftSupplierOrdersBySupplierController.definition.url
            .replace('{supplier}', parsedArgs.supplier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\GetDraftSupplierOrdersBySupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetDraftSupplierOrdersBySupplierController.php
* @route '/api/supplier/{supplier}/draft-supplier-orders'
*/
GetDraftSupplierOrdersBySupplierController.get = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDraftSupplierOrdersBySupplierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SupplierOrder\GetDraftSupplierOrdersBySupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetDraftSupplierOrdersBySupplierController.php
* @route '/api/supplier/{supplier}/draft-supplier-orders'
*/
GetDraftSupplierOrdersBySupplierController.head = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDraftSupplierOrdersBySupplierController.url(args, options),
    method: 'head',
})

export default GetDraftSupplierOrdersBySupplierController